module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-regular.347639ec.woff";